"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _UserAvatar = _interopRequireDefault(require("../User/UserAvatar"));

var PostAuthor = function PostAuthor(_ref) {
  var author = _ref.author;
  return (0, _preact.h)(_UserAvatar.default, {
    user: author,
    extraClass: "avatar avatar--responsive",
    showRank: true
  });
};

var _default = PostAuthor;
exports.default = _default;